module.exports = __webpack_public_path__ + "static/media/snap.33669edf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/snap.svg
// module id = 633
// module chunks = 0